import { Moment } from 'moment';
import { createContext, useContext } from 'react';
import { Segment } from '../types';

type UrlParamsContextState = {
  exportUrlCAFFOn: boolean;
  campaignId: undefined | number;
  medium: undefined | string;
  startTimeParam: undefined | Moment;
  endTimeParam: undefined | Moment;
  timePresetParam: undefined | string;
  timezoneParam: undefined | string;
  overviewMetricsParam: undefined | string[];
  timeSeriesMetricsParam: undefined | string[];
  segmentMetricsParam: undefined | string[];
  segmentParam: undefined | Segment;
  regionParam: undefined | string;
  variantIdParam: string | number;
};

export const initialUrlParamsContextState = {
  exportUrlCAFFOn: false,
  campaignId: undefined,
  medium: undefined,
  startTimeParam: undefined,
  endTimeParam: undefined,
  timePresetParam: undefined,
  timezoneParam: undefined,
  overviewMetricsParam: undefined,
  timeSeriesMetricsParam: undefined,
  segmentMetricsParam: undefined,
  segmentParam: undefined,
  regionParam: undefined,
  variantIdParam: 'default',
};

export const UrlParamsContext = createContext<UrlParamsContextState>(initialUrlParamsContextState);

export const useUrlParamsContext = () => useContext(UrlParamsContext);
